import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("bf_token") || "");
  const [email, setEmail] = useState(() => localStorage.getItem("bf_email") || "");
  const [role, setRole] = useState(() => localStorage.getItem("bf_role") || "");

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bf_token", data.token);
    localStorage.setItem("bf_email", data.email);
    localStorage.setItem("bf_role", data.role || "admin");
    setToken(data.token);
    setEmail(data.email);
    setRole(data.role || "admin");
    return data;
  };

  const logout = () => {
    localStorage.removeItem("bf_token");
    localStorage.removeItem("bf_email");
    localStorage.removeItem("bf_role");
    setToken(""); setEmail(""); setRole("");
  };

  return (
    <AuthCtx.Provider value={{ token, email, role, isAuthed: !!token, isAdmin: role === "admin", isStaff: role === "staff", login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
